import { auth, firestore } from '../config/firebase';

const getUserProfileFromFirestore = async (uid) => {
    try {
        const userDoc = await firestore.collection('users').doc(uid).get();
        if (userDoc.exists) {
            return userDoc.data();
        }
        return null;
    } catch (error) {
        return null;
    }
};

export const isAdmin = async (user, profile = null) => {
    if (!user) return false;

    let userProfile = profile;
    if (!userProfile && user.uid) {
        userProfile = await getUserProfileFromFirestore(user.uid);
    }

    if (userProfile) {
        if (
            userProfile.role === 'admin' ||
            userProfile.role === 'super' ||
            userProfile.type === 'admin' ||
            userProfile.isAdmin === true
        ) {
            return true;
        }
    }

    try {
        const currentUser = auth.currentUser;
        if (currentUser && currentUser.uid === user.uid) {
            const idTokenResult = await currentUser.getIdTokenResult();
            if (
                idTokenResult.claims.admin === true ||
                idTokenResult.claims.role === 'admin' ||
                idTokenResult.claims.role === 'super'
            ) {
                return true;
            }
        }
    } catch (error) {}

    if (user.role === 'admin' || user.role === 'super' || user.isAdmin === true) {
        return true;
    }

    try {
        const adminDoc = await firestore.collection('admins').doc(user.uid).get();
        if (adminDoc.exists) {
            const adminData = adminDoc.data();
            return adminData.isActive === true;
        }
    } catch (error) {}

    return false;
};

export const isAdminSync = (user, profile = null) => {
    if (!user) return false;

    const userProfile = profile || user.profile;

    if (userProfile) {
        if (
            userProfile.role === 'admin' ||
            userProfile.role === 'super' ||
            userProfile.type === 'admin' ||
            userProfile.isAdmin === true
        ) {
            return true;
        }
    }

    if (user.role === 'admin' || user.role === 'super' || user.isAdmin === true) {
        return true;
    }

    return false;
};

export const updateUserRole = async (uid, role) => {
    try {
        await firestore.collection('users').doc(uid).update({
            role: role,
            isAdmin: role === 'admin' || role === 'super',
            updatedAt: new Date().toISOString()
        });
        return true;
    } catch (error) {
        return false;
    }
};

export const addAdmin = async (uid, adminData = {}) => {
    try {
        await firestore.collection('admins').doc(uid).set({
            uid: uid,
            isActive: true,
            addedAt: new Date().toISOString(),
            ...adminData
        });
        await updateUserRole(uid, 'admin');
        return true;
    } catch (error) {
        return false;
    }
};

export const removeAdmin = async (uid) => {
    try {
        await firestore.collection('admins').doc(uid).update({
            isActive: false,
            removedAt: new Date().toISOString()
        });
        await updateUserRole(uid, 'user');
        return true;
    } catch (error) {
        return false;
    }
};

export const canModerateExperiences = async (user, profile = null) => {
    return await isAdmin(user, profile);
};

export const canCreateExperience = (user) => {
    return !!user;
};

export const canComment = (user) => {
    return !!user;
};

export const canReact = (user) => {
    return !!user;
};

export const addPermissionsToUser = async (user, profile = null) => {
    if (!user) return null;

    const adminStatus = await isAdmin(user, profile);

    return {
        ...user,
        isAdmin: adminStatus,
        canModerateExperiences: adminStatus,
        canCreateExperience: canCreateExperience(user),
        canComment: canComment(user),
        canReact: canReact(user)
    };
};

export const addPermissionsToUserSync = (user, profile = null) => {
    if (!user) return null;

    const adminStatus = isAdminSync(user, profile);

    return {
        ...user,
        isAdmin: adminStatus,
        canModerateExperiences: adminStatus,
        canCreateExperience: canCreateExperience(user),
        canComment: canComment(user),
        canReact: canReact(user)
    };
};

export const getUserPermissions = async (user, profile = null) => {
    const adminStatus = await isAdmin(user, profile);

    return {
        isAdmin: adminStatus,
        canModerateExperiences: adminStatus,
        canCreateExperience: canCreateExperience(user),
        canComment: canComment(user),
        canReact: canReact(user)
    };
};

export const getUserPermissionsSync = (user, profile = null) => {
    const adminStatus = isAdminSync(user, profile);

    return {
        isAdmin: adminStatus,
        canModerateExperiences: adminStatus,
        canCreateExperience: canCreateExperience(user),
        canComment: canComment(user),
        canReact: canReact(user)
    };
};
